export default "__VITE_ASSET__BXEhTPlg__"